<template>
  <!-- Search Filter -->
  <div class="row filter-row">
    <div class="col-sm-6 col-md-3">
      <v-autocomplete v-model="selectedEmployee" :items="employeeOptions" variant="outlined" density="comfortable"
        item-title="text" item-value="text" clearable label="Employee Name" @update:model-value="searchClicked"></v-autocomplete>
    </div>
    <div class="col-sm-6 col-md-3">
      <div class="input-block mb-3 form-focus select-focus">
        <vue-select :options="Months" v-model="month" id="month" placeholder="-" @update:model-value="searchClicked"/>
        <label class="focus-label">Select Month</label>
      </div>
    </div>
    <div class="col-sm-6 col-md-3">
      <div class="input-block mb-3 form-focus select-focus">
        <vue-select :options="Year" v-model="year" id="year" placeholder="-" @update:model-value="searchClicked"/>
        <label class="focus-label">Select Year</label>
      </div>
    </div>
    <!-- <div class="col-sm-6 col-md-3">
      <div class="d-grid">
        <a href="javascript:;" class="btn btn-success" @click="searchClicked"> Search </a>
      </div>
    </div> -->
  </div>
  <!-- /Search Filter -->
</template>
<script>
import axios from "axios";
import { VUE_APP_API_BASE_URL } from "../config";

export default {
  data() {
    return {
      select2: null,
      Months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December ",
      ],
      Year: this.getYears(),
      selectedEmployee: null,
      employeeOptions: [],
      month: (new Date()).toLocaleString('default', { month: 'long' }),
      year: String((new Date()).getFullYear()),
    };
  },
  mounted() {
    this.getEmployees();
  },
  methods: {
    async getEmployees() {
      await axios.get(`${VUE_APP_API_BASE_URL}/user/user-list`)
        .then((response) => {
          if (response.data.status) {
            this.employeeOptions = response.data.data.map(element => ({
              id: element.id,
              text: `${element.first_name} ${element.last_name}`
            }));
          }
        }).catch(function (error) {
          console.log(error);
        });
    },
    searchClicked() {
      this.$emit("attFilterClicked", {
        month: (new Date(`${this.month} 1, 2024`)).getMonth() + 1,
        year: this.year,
        employee_name: this.selectedEmployee,
      });
    },
    getYears() {
      let years = [];
      let currentYear = (new Date()).getFullYear();
      for (let i = 0; i < 5; i++) {
        years.push(String(currentYear));
        currentYear -= 1;
      }
      return years;
    }
  },
};
</script>
